/* eslint-disable-next-line */
export const only = (obj, keys) => {
  const ret = {};
  Object.keys(obj).forEach(key => {
    if (keys.includes(key)) ret[key] = obj[key];
  });
  return ret;
};



// WEBPACK FOOTER //
// ./src/utils/index.js